import React from "react";

const TimelineContext = React.createContext<{ from: string; to: string }>({
  from: "",
  to: "",
});

export default TimelineContext;
